import { questionTypes } from 'sharedParts';
import {
  KEY_BUTTON_BACKGROUND_COLOR_KEY,
  KEY_BUTTON_FONT_COLOR_KEY,
  KEY_SELECTION_COLOR,
} from '../../const/keysBlockStyling';

export const buttonStylingToBlockModelMap = {
  [KEY_BUTTON_BACKGROUND_COLOR_KEY]: 'backgroundColor',
  [KEY_BUTTON_FONT_COLOR_KEY]: 'textColor',
};

const genericConfig = {
  [KEY_SELECTION_COLOR]: 'color',
};

const stylingKeysToBlockProps = {
  [questionTypes.nextButton]: buttonStylingToBlockModelMap,
  [questionTypes.redirectButton]: buttonStylingToBlockModelMap,
  [questionTypes.submitButton]: buttonStylingToBlockModelMap,
  [questionTypes.respondentBlankField]: genericConfig,
  [questionTypes.respondentCompanyName]: genericConfig,
  [questionTypes.respondentMail]: genericConfig,
  [questionTypes.respondentFirstName]: genericConfig,
  [questionTypes.respondentLastName]: genericConfig,
  [questionTypes.respondentPhone]: genericConfig,
  [questionTypes.respondentInfoMulti]: genericConfig,
  [questionTypes.respondentInfoRadio]: genericConfig,
  [questionTypes.respondentInfoLongText]: genericConfig,
  [questionTypes.respondentInfoShortText]: genericConfig,
  [questionTypes.respondentInfoDropdown]: genericConfig,
  [questionTypes.shortText]: genericConfig,
  [questionTypes.longText]: genericConfig,
  [questionTypes.questionDropdown]: genericConfig,
  [questionTypes.questionImageMulti]: genericConfig,
  [questionTypes.questionImageSingle]: genericConfig,
  [questionTypes.questionMulti]: genericConfig,
  [questionTypes.questionScale]: genericConfig,
  [questionTypes.questionNumeric]: genericConfig,
  [questionTypes.questionMatrixRadio]: genericConfig,
  [questionTypes.questionMatrixMulti]: genericConfig,
  [questionTypes.questionMatrixScale]: genericConfig,
  [questionTypes.questionSingle]: genericConfig,
  [questionTypes.socialFollow]: genericConfig,
  [questionTypes.staticText]: genericConfig,
};

export default stylingKeysToBlockProps;
